const initialState = { home_amount: 0, show_fare_amount: 0 };

const ReservationTotalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationTotal":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationTotalReducer;
